export default __webpack_public_path__ + "img/remove-attachment.acb40616.svg";